// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-fc3b5328] .chart-form-item-warp {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
[data-v-fc3b5328] .chart-form-item-warp .jz-chart-title-label {
  width: 80px;
  margin-right: 10px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  text-align: left;
  font-style: normal;
  font-family: Microsoft YaHei UI;
  white-space: nowrap;
  flex-shrink: 0;
}
[data-v-fc3b5328] .common-style-config {
  width: 100%;
  height: 100%;
}
[data-v-fc3b5328] .el-form-item__content {
  color: var(--bi-jz-sub-color) !important;
  line-height: 1;
}
[data-v-fc3b5328] .el-form-item__label {
  margin-bottom: 8px;
  line-height: 1;
  padding-bottom: 0;
  color: var(--bi-jz-sub-color) !important;
}
[data-v-fc3b5328] .el-radio {
  margin-right: 6px;
}
[data-v-fc3b5328] .el-collapse-item__header {
  direction: rtl;
  padding: 0 12px;
  display: block;
  text-align: left;
  background-color: var(--bi-jz-bg-color);
  color: var(--bi-jz-font-color);
  border-color: var(--bi-jz-border-color);
}
[data-v-fc3b5328] .el-form-item--mini.el-form-item {
  margin-bottom: 0;
}
[data-v-fc3b5328] .el-collapse-item__header.is-active {
  border-color: transparent;
}
[data-v-fc3b5328] .el-collapse {
  border-top-color: transparent;
  border-bottom-color: transparent;
}
[data-v-fc3b5328] .el-collapse-item__content {
  padding-bottom: 12px;
}
[data-v-fc3b5328] .el-collapse-item__wrap {
  background-color: var(--bi-jz-bg-color);
  border-bottom-color: var(--bi-jz-border-color);
  padding: 0 12px;
}
[data-v-fc3b5328] .el-collapse-item__wrap * {
  color: var(--bi-jz-font-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/styleComp/commonConfig.vue","webpack://./commonConfig.vue"],"names":[],"mappings":";AAkGA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;ACjGF;AD8FA;EAMI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,mBAAA;EACA,cAAA;ACjGJ;ADqGA;EACE,WAAA;EACA,YAAA;ACnGF;ADsGA;EACE,wCAAA;EACA,cAAA;ACpGF;ADuGA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,wCAAA;ACrGF;ADwGA;EACE,iBAAA;ACtGF;ADyGA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;EACA,8BAAA;EACA,uCAAA;ACvGF;AD0GA;EACE,gBAAA;ACxGF;AD2GA;EACE,yBAAA;ACzGF;AD4GA;EACE,6BAAA;EACA,gCAAA;AC1GF;AD6GA;EACE,oBAAA;AC3GF;AD8GA;EACE,uCAAA;EACA,8CAAA;EACA,eAAA;AC5GF;ADyGA;EAMI,8BAAA;AC5GJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/deep/ .chart-form-item-warp {\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n\n  .jz-chart-title-label {\n    width: 80px;\n    margin-right: 10px;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1;\n    text-align: left;\n    font-style: normal;\n    font-family: Microsoft YaHei UI;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n}\n\n/deep/ .common-style-config {\n  width: 100%;\n  height: 100%;\n}\n\n/deep/ .el-form-item__content {\n  color: var(--bi-jz-sub-color) !important;\n  line-height: 1;\n}\n\n/deep/ .el-form-item__label {\n  margin-bottom: 8px;\n  line-height: 1;\n  padding-bottom: 0;\n  color: var(--bi-jz-sub-color) !important;\n}\n\n/deep/ .el-radio {\n  margin-right: 6px;\n}\n\n/deep/ .el-collapse-item__header {\n  direction: rtl;\n  padding: 0 12px;\n  display: block;\n  text-align: left;\n  background-color: var(--bi-jz-bg-color);\n  color: var(--bi-jz-font-color);\n  border-color: var(--bi-jz-border-color);\n}\n\n/deep/ .el-form-item--mini.el-form-item {\n  margin-bottom: 0;\n}\n\n/deep/ .el-collapse-item__header.is-active {\n  border-color: transparent\n}\n\n/deep/ .el-collapse {\n  border-top-color: transparent;\n  border-bottom-color: transparent\n}\n\n/deep/ .el-collapse-item__content {\n  padding-bottom: 12px;\n}\n\n/deep/ .el-collapse-item__wrap {\n  background-color: var(--bi-jz-bg-color);\n  border-bottom-color: var(--bi-jz-border-color);\n  padding: 0 12px;\n\n  * {\n    color: var(--bi-jz-font-color);\n  }\n}\n\n"," /deep/ .chart-form-item-warp {\n  display: flex;\n  align-items: center;\n  margin-top: 6px;\n}\n /deep/ .chart-form-item-warp .jz-chart-title-label {\n  width: 80px;\n  margin-right: 10px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1;\n  text-align: left;\n  font-style: normal;\n  font-family: Microsoft YaHei UI;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n /deep/ .common-style-config {\n  width: 100%;\n  height: 100%;\n}\n /deep/ .el-form-item__content {\n  color: var(--bi-jz-sub-color) !important;\n  line-height: 1;\n}\n /deep/ .el-form-item__label {\n  margin-bottom: 8px;\n  line-height: 1;\n  padding-bottom: 0;\n  color: var(--bi-jz-sub-color) !important;\n}\n /deep/ .el-radio {\n  margin-right: 6px;\n}\n /deep/ .el-collapse-item__header {\n  direction: rtl;\n  padding: 0 12px;\n  display: block;\n  text-align: left;\n  background-color: var(--bi-jz-bg-color);\n  color: var(--bi-jz-font-color);\n  border-color: var(--bi-jz-border-color);\n}\n /deep/ .el-form-item--mini.el-form-item {\n  margin-bottom: 0;\n}\n /deep/ .el-collapse-item__header.is-active {\n  border-color: transparent;\n}\n /deep/ .el-collapse {\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n}\n /deep/ .el-collapse-item__content {\n  padding-bottom: 12px;\n}\n /deep/ .el-collapse-item__wrap {\n  background-color: var(--bi-jz-bg-color);\n  border-bottom-color: var(--bi-jz-border-color);\n  padding: 0 12px;\n}\n /deep/ .el-collapse-item__wrap * {\n  color: var(--bi-jz-font-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
